import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environment';

export type WorkerProviderId = 'runpod';

export interface WorkerProviderSummary {
  id: WorkerProviderId;
  name: string;
  configured: boolean;
  enabled: boolean;
}

export type RunpodEndpointHealthStatus = 'healthy' | 'degraded' | 'offline';

export interface RunpodEndpointStatus {
  id: string;
  name: string;
  templateId: string | null;
  gpuCount: number;
  workersMin: number | null;
  workersMax: number | null;
  gpuIds: string[];
  workersReady: number;
  workersIdle: number;
  workersThrottled: number;
  workersInProgress: number;
  jobsQueued: number;
  jobsInProgress: number;
  healthStatus: RunpodEndpointHealthStatus;
  healthError?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class WorkerProviderService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = environment.sionnaApiUrl;

  getProviders(): Observable<WorkerProviderSummary[]> {
    return this.http.get<WorkerProviderSummary[]>(`${this.apiBaseUrl}/api/worker-providers`);
  }

  getRunpodEndpointStatuses(): Observable<RunpodEndpointStatus[]> {
    return this.http.get<RunpodEndpointStatus[]>(`${this.apiBaseUrl}/api/worker-providers/runpod/endpoints`);
  }
}